/**
 * useKey : renameKey
 */
export const SUBMIT_FLOOR_TYPE = {
  // 订单信息
  SUBMIT_FLOOR: {
    SUBMIT_FLOOR_NAMESPACE: "core.trade-FLR#balance.order-M#defaultOrderFloor",
    STRUCTURE: {
      "C-M#orderFloor&basic": {
        orderId: "orderId",
        factPrice: "factPrice",
        idPaymentType: "idPaymentType",
        submitSkuNum: "submitSkuNum",
      },
      "C-D#orderInfoDecorator&basic": {
        orderType: "orderType",
        useScore: "useScore",
        idCompanyBranch: "idCompanyBranch",
      },
      "VCYBB2C-D#submitResult&basic": {
        payId: "payId",
        payInfo: "payInfo",
        zeroOrderFlag: "zeroOrderFlag",
      },
      "C-D#couponCodeFailDecorator&couponCodeFail": {
        activityId: "activityId",
        batchId: "batchId",
      },
    },
  },
  // 部分无货楼层
  SOME_OUT_STOCK_FLOOR: {
    SOME_OUT_STOCK__NAMESPACE: "core.trade-FLR#balance.order-M#defaultOrderFloor",
    STRUCTURE: {
      "C-D#orderNoStockDecorator&stock": {
        noStockTitle: "noStockTitle",
        stockStatus: "stockStatus",
      },
    },
    PART_LIST_NAMESPACE: "core.trade-FLR#balance.order-P#skuOrderPart",
    PART_LIST_STRUCTURE: {
      "C-P#skuOrderPart&basic": {
        skuId: "skuId",
        skuName: "skuName",
        num: "num",
        imgUrl: "imgUrl",
        saleAttributes: "saleAttributes",
        promoRemainNum: "promoRemainNum",
        isHitSumPromo: "isHitSumPromo",
        sumPromoId: "sumPromoId",
        unitPromoDiscount: "unitPromoDiscount",
      },
      "C-P#skuOrderPart&price": {
        deliveryPrice: "deliveryPrice",
        price: "price",
      },
    },
  },
};
